import React from "react";
import { TrendingUp, Users, Eye, ShoppingCart, Package, Star, Calendar, DollarSign } from "lucide-react";

export function PageStats({ pageData, bgClass, productCount = 0, pageType }) {
  // Generate dynamic stats based on page type and actual data
  const generateStats = () => {
    const baseStats = [
      {
        label: pageType === "deal" || pageType === "deals" ? "Deals" : "Products",
        value: productCount.toLocaleString(),
        icon: pageType === "deal" || pageType === "deals" ? DollarSign : ShoppingCart,
        color: "text-blue-600",
      },
    ];

    // Add different stats based on page type
    switch (pageType) {
      case "deal":
      case "deals":
        return [
          ...baseStats,
          {
            label: "Avg Savings",
            value: "25%",
            icon: TrendingUp,
            color: "text-green-600",
          },
          {
            label: "Active Today",
            value: Math.ceil(productCount * 0.7).toLocaleString(),
            icon: Calendar,
            color: "text-orange-600",
          },
          {
            label: "Top Rated",
            value: Math.ceil(productCount * 0.3).toLocaleString(),
            icon: Star,
            color: "text-yellow-600",
          },
        ];

      case "use-case":
        return [
          ...baseStats,
          {
            label: "Categories",
            value: pageData.categories ? pageData.categories.length : "3",
            icon: Package,
            color: "text-purple-600",
          },
          {
            label: "Reviews",
            value: "2.1K",
            icon: Star,
            color: "text-yellow-600",
          },
          {
            label: "Updated",
            value: "Daily",
            icon: Calendar,
            color: "text-green-600",
          },
        ];

      case "brand":
        return [
          ...baseStats,
          {
            label: "Brand",
            value: Math.ceil(productCount / 8).toLocaleString(),
            icon: Package,
            color: "text-purple-600",
          },
          {
            label: "Popular",
            value: Math.ceil(productCount * 0.4).toLocaleString(),
            icon: TrendingUp,
            color: "text-green-600",
          },
          {
            label: "Reviews",
            value: "1.8K",
            icon: Eye,
            color: "text-blue-600",
          },
        ];

      default:
        return [
          ...baseStats,
          {
            label: "Views",
            value: "1.2K",
            icon: Eye,
            color: "text-green-600",
          },
          {
            label: "Active Users",
            value: "89",
            icon: Users,
            color: "text-purple-600",
          },
          {
            label: "Trending",
            value: "↑ 12%",
            icon: TrendingUp,
            color: "text-orange-600",
          },
        ];
    }
  };

  const stats = generateStats();

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`${bgClass} dark:bg-[#0f1729] rounded-xl border border-slate-200 dark:border-[#1e2d4a] rounded-xl p-6 shadow-sm border border-white`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-900 mt-1">{stat.value}</p>
            </div>
            <div className={`${stat.color} opacity-80`}>
              <stat.icon className="w-6 h-6" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
